export enum BenchmarkDetailsErrors {
  cantPushTimeWindowsToPA = 'Please set caclulation frequency to non-daily',
}
